import { render, staticRenderFns } from "./FormatsGellaryRecucler.vue?vue&type=template&id=5d654e1e&"
import script from "./FormatsGellaryRecucler.vue?vue&type=script&lang=ts&"
export * from "./FormatsGellaryRecucler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports